import { useFlags } from "launchdarkly-react-client-sdk";

import { getSpaceExternalId } from "@/content-hub/store/selectors";
import { useAppSelector } from "@/redux/store";

/**
 * Returns the current space external ID when the pre-event-organization-spaces
 * flag is on, otherwise undefined. Pass the return value directly into
 * ContentLibrary options.spaceExternalId — undefined omits the param from the
 * recordings request so org-wide behaviour is fully preserved when the flag is off.
 */
export function useSpaceFilter(): string | undefined {
  const spaceExternalId = useAppSelector(getSpaceExternalId);
  const { preEventOrganizationSpaces: spacesEnabled } = useFlags();

  if (!spacesEnabled) return undefined;

  return spaceExternalId ?? undefined;
}
